import AwesomeAlert from './src/AwesomeAlert';

export default AwesomeAlert;
